export interface AffiliateSubCodeDetailsModel {
  id: number;
  name: string;
  code: string;
}
